import React from 'react';

export default function SeoLayout({ children }) {
  return (
    <div className="seo-layout">
      {children}
    </div>
  );
}
